import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import "../theme/default.styl";
Vue.use(Vuetify, {
  theme: {
    primary: "#1565C0",
    secondary: "#37474F",
    accent: "#00BCD4",
    error: "#F44336",
    info: "#0288D1",
    success: "#43A047",
    warning: "#FB8C00"
  },
  customProperties: true,
  iconfont: "fa4"
});
